import { Body, FormContent } from 'components';
import { styled } from 'libs/ui/styled';

export const FormContentStyled = styled(FormContent)(({ theme }) => ({
  maxWidth: 951,

  [theme.breakpoints.up('mobile')]: {
    marginTop: 'auto',
  },
}));

export const BodyStyled = styled(Body)(({ theme }) => ({
  marginTop: 16,
  marginBottom: 16,

  padding: 64,
  [theme.breakpoints.down('tablet')]: {
    padding: 54,
  },
  [theme.breakpoints.down('mobile')]: {
    padding: 0,
    margin: 0,
    background: 'none',
  },

  '.registration-onboarding-button': {
    alignItems: 'flex-end',
    [theme.breakpoints.down('tablet')]: {
      alignItems: 'normal',
    },
  },

  '.registration-onboarding-content': {
    [theme.breakpoints.down('tablet')]: {
      gap: 12,
    },
  },
}));
